import React from 'react';
import { Link } from 'react-router-dom';
import NavigationLinks from '../components/NavigationLinks';

export default function Analytics() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-20 font-sans">
      <NavigationLinks />
      
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-slate-900">📈 System Analytics</h1>
        <p className="text-slate-500 mt-2">Fleet-wide performance metrics</p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white rounded-xl border border-slate-200 p-6 shadow-sm">
          <div className="text-2xl font-bold text-indigo-600">94%</div>
          <div className="text-sm text-slate-500">Average Accuracy</div>
          <div className="mt-2 h-1.5 bg-slate-100 rounded-full overflow-hidden">
            <div className="h-full bg-indigo-600 rounded-full" style={{ width: '94%' }} />
          </div>
        </div>
        
        <div className="bg-white rounded-xl border border-slate-200 p-6 shadow-sm">
          <div className="text-2xl font-bold text-green-600">1,247</div>
          <div className="text-sm text-slate-500">Total Cases Analyzed</div>
          <div className="text-xs text-slate-400 mt-1">+12% from last month</div>
        </div>
        
        <div className="bg-white rounded-xl border border-slate-200 p-6 shadow-sm">
          <div className="text-2xl font-bold text-amber-600">4.2s</div>
          <div className="text-sm text-slate-500">Avg. Inference Time</div>
          <div className="text-xs text-slate-400 mt-1">Within target range</div>
        </div>
      </div>
      
      <Link to="/insights" className="inline-block mt-8 text-indigo-600 hover:text-indigo-800">
        ← Back to Insights
      </Link>
    </div>
  );
}
